var _style, _rect, _path, _defs, _g, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMetPoliceLogoOutlined(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_406",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 301.9 82.1",
    style: {
      enableBackground: "new 0 0 301.9 82.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#0033A1;}\r\n\t.st2{clip-path:url(#SVGID_2_);}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 109.9,
    y: -109.9,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 192 -109.9004)",
    className: "st0",
    width: 82.1,
    height: 301.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_196",
    className: "st1",
    d: "M3,3v76.1h83.5V3H3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_184"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 3,
    y: 3,
    width: 295.8,
    height: 76.1
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_183"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_197",
    className: "st0",
    d: "M45.8,9.5c-0.4,0.2-0.5,0.6-0.5,1.1c1.7,0,3.4-1.8,5.1-0.2c0.7,0.6,0.9,1.6,0.7,2.5 c-0.1,0.8-0.4,1.7-0.7,2.4c-0.1,0.2-0.3,0.7-0.8,0.5S49,15.4,49.2,15c0.2-0.5,1.3-2.1,0.9-3.4c-0.2-0.6-0.7-1-1.3-1.1 c-0.9,0-2.6,1-3.4,1.3v3.1h-1.3v-3.2c-1.3-0.5-2.8-1.9-4.2-0.9c-0.6,0.5-0.8,1.3-0.6,2.1c0.2,0.7,0.5,1.3,0.8,2 c0.2,0.3,0,0.6-0.2,0.8l0,0c-0.2,0.1-0.5,0.1-0.7,0c-0.4-0.3-1.5-3.3-0.4-4.8c0.5-0.7,1.3-1.1,2.1-1.1c1.3-0.1,2.1,0.7,3.4,0.8 c0-0.4,0-0.9-0.5-1.1c0-0.6,0.3-1.2,0.9-1.5c0.6,0.2,1,0.8,1,1.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_198",
    className: "st0",
    d: "M49.7,16.3c0.2,0.1,0.2,0.4,0.1,0.6l0,0c-3.2-0.5-6.6-0.5-9.8,0c-0.2-0.3,0-0.6,0.4-0.7 c3.1-0.9,6.3-0.9,9.4,0.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_199",
    className: "st0",
    d: "M66.1,17.8c0,0.1,0.4,1.1-0.5,1.2c-1.5,0-1-1.6-2.7-1.9c-2.2-0.3-2.9,2.2-3.9,3.7 c-1.4,2.5-3.2,5.8-6.4,6c-1,0-2-0.2-2.8-0.9c-0.2-0.3,0-0.6,0.4-0.7c0.5,0,0.8,0.5,1.3,0.7c0.8,0.3,1.7,0.1,2.4-0.4 c2.4-2.4,3.3-5.3,5.6-7.8c1.2-1.2,3-1.7,4.7-1.3C65,16.6,65.7,17.1,66.1,17.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_200",
    className: "st0",
    d: "M35.9,25.5c0.6,0.6,2.9,0.4,2.3,1.3c-1.2,0.7-3.4,0-5.4-2.9c-1.5-2.2-3.4-5.9-4.8-6.6 c-0.6-0.2-1.2-0.1-1.7,0.2c-0.9,0.5-1,2.3-2.4,1.5c-0.3-0.3-0.3-0.7-0.1-1.1c1.1-1.3,2.8-1.8,4.4-1.3c2.7,0.6,3.8,3.8,5.3,5.9 c0.5,1.2,1.3,2.2,2.3,3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_201",
    className: "st0",
    d: "M55.7,17.7c0.8,0.9,0.3,2.1,0.3,3.2s0,0.6-0.3,0.7c-0.4,0-0.5-0.6-0.6-0.9 c-0.2-1.1,0-2.6-1-3.1c-0.3-0.1-0.6-0.1-0.9,0.1c-0.8,0.6,0.3,2.4-1.2,1.9c-0.5-0.2-0.2-1.1,0-1.5c0.3-0.6,0.9-1,1.6-1.1 C54.4,16.9,55.1,17.1,55.7,17.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_202",
    className: "st0",
    d: "M37.8,18c0.3,0.4,0.4,1,0.2,1.5c0,0.3-0.5,0.3-0.8,0.1c-0.5-0.6,0-2-0.9-2.1 c-2.1-0.2-0.7,3.1-2.1,4c-0.6,0,0-1-0.4-1.9c-0.2-0.6-0.1-1.2,0.2-1.8c0.3-0.4,0.8-0.7,1.4-0.8c0.9-0.2,1.8,0.2,2.3,0.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_203",
    className: "st0",
    d: "M49.8,17.9c0.1,0.1,0.2,0.3,0,0.4l0,0c-3.2,0.3-6.5,0.3-9.7,0c-0.2-0.1,0-0.4,0-0.5 c3.1-0.8,6.3-0.9,9.4-0.1h0.2L49.8,17.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_204",
    className: "st0",
    d: "M45.8,19.6c1.2,0.7,2.2,1.6,3,2.7c0.2,0.3-0.2,0.8-0.8,0.5c-0.9-0.5-1.2-1.2-2-1.8 c-1-0.8-1.8,0.1-2.6,0.5l-1.9,1.3c-0.3,0.2-0.7,0-0.9-0.2l0,0c-0.3-0.5,1-1.3,1.7-1.7C43.3,20.4,45,19.2,45.8,19.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_205",
    className: "st0",
    d: "M64.2,21.9c1,0.4,1.5,1.6,1.2,2.6c-0.2,0.4-0.6,1.1-1.1,1.1c-0.3,0-0.6-0.2-0.8-0.5 c-0.3-0.9,1.6-1.2,0.9-2.4c-0.2-0.4-0.8-0.6-1.2-0.3c0,0,0,0-0.1,0c-1.6,1.2-2.9,3.7-5.1,2.6l0,0c0-0.5,0.8-0.2,1.3-0.5 C60.9,23.5,62.1,21,64.2,21.9L64.2,21.9L64.2,21.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_206",
    className: "st0",
    d: "M31.9,24.9L31.9,24.9c-0.3,0.6-0.7,0.6-1.2,0.6c-2.5,0-2.8-3.5-5.1-2.7 c-0.6,0.3-0.8,0.8-0.5,1.3c0.4,0.4,1.2,0.4,1.3,1c0,0.4-0.5,0.7-0.9,0.7c-0.5-0.2-0.9-0.6-1.1-1.1c-0.2-0.6-0.1-1.2,0.2-1.8 c0.7-0.8,1.9-1.1,2.9-0.7c1.6,0.6,2.5,3,4.3,2.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_207",
    className: "st0",
    d: "M46.1,26.1l-0.8,0.4l-3.4,1.6c-0.9-0.7-1.8-1.4-2.6-2c-0.2-0.3-0.2-0.5,0-0.6 c0.2-0.3,0.4-0.3,0.9,0l1.8,1.4l3.6-1.7C46,25,46.5,25.7,46.1,26.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_208",
    className: "st0",
    d: "M59.2,27.1c0,0.3,0,0.5-0.3,0.6c-0.1,0-0.2,0-0.3,0c-0.4,0-0.7-0.3-0.9-0.6 c-0.2-0.4,0-0.8,0.4-0.8C58.6,26.3,59,26.6,59.2,27.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    className: "st0",
    d: "M32.4,27c0,0.5-0.4,0.9-0.9,0.9c-0.2,0-0.4,0-0.5-0.2c0-0.5,0.2-0.9,0.7-1.1 C32,26.5,32.4,26.6,32.4,27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_210",
    className: "st0",
    d: "M49.5,27c-0.7,1-1,2.3-0.8,3.5c0.7,2,2.6,1.7,2.2,2.9c-0.3,0.5-1.3,0.3-2.2,0.3 c-2.9-0.2-4.6,3.9-7.3,2.6L40,35.6h-7.3v6.7c1.1,1.1,1.7,2.6,1.6,4.1c0,0.4-0.4,0.8-0.8,0.8c-0.9,0-2.4,0.3-2.6-0.8 c-0.2-0.8,0-2.1-1-2.4c-0.3,0-0.9-0.2-1.1,0c-0.2,0.4-0.2,0.9-0.7,1.1C26,45.4,25.8,43,24.8,42c-0.3-0.1-0.5-0.5-0.4-0.8 c0.2-0.4,0.6-0.3,0.9-0.2c1.1,0.9,1.1,2.4,2.2,3.1c0.9,0,0.3-1,1-1.1c0.9-0.2,1.8,0,2.5,0.5c0.5,0.7,0.7,1.6,0.8,2.5 c0.1,0.4,0.9,0.4,1.3,0.3c0.4-0.2,0.4-0.7,0-1.9c-0.5-2.2-4.3-2.3-5.9-4.5c-0.5-0.5-0.7-1.2-0.5-1.9c0.3-0.6,1-0.4,1.4-0.7 c0.3-0.4-1-1.7-0.7-2.1c2-1.3,4.3-3,5.1-5.2c0.3-0.7-0.9-1.2-0.8-1.6l1-0.9c0.5,0,0.5,1.1,0.9,0.9l0.4-0.5 c0.5-0.3,1.4,0.5,1.8,1.1c0.6,0.9,0.9,2.1,0.5,2.3c-0.6,0.5-0.5,0.7,0,1.1c-0.4,0.1-0.8,0.4-1,0.8c-0.4,0-0.6-0.8-0.7-1.2 c-0.2-0.8,1-0.8,0.8-1.6c-0.2-0.7-0.9-1.5-1.2-1.3c-0.7,0.8-1,2-1.7,3c-1,1.5-2.4,2.7-3.9,3.5c-0.2,0.3,0.8,1.9,0.6,2.4 c-0.5,0.3-1.8,0-1.5,0.9c0.9,1.3,2.2,2.2,3.6,2.7v-7.1H35c0.3,0.5,0.9,0.7,1.4,0.5c0.6,0,0.8-0.5,1.3-0.5c0.8-0.2,2,0.3,2.5-0.5 c0.4,0.7,1,1.1,1.7,1.2c2.2,0.2,4.4-3.5,7.4-2.6c-1.6-0.8-2.3-2.7-1.6-4.3c0.3-0.7,0.7-1.3,1.4-1.8c0,0,0.5-0.3,0.3,0.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_211",
    className: "st0",
    d: "M67.8,27.8c1.3,0,3.4-0.3,3.9,0.4c0.4,0.6,0.3,1.7,0.9,1.9c0.7,0,1.5,0,1.8,0.7 s0.2,1.6-0.1,2.3c-0.3,0.4-0.6,0.8-1,1c0,1,0.7,2.4,0.2,3.1c-0.2,0.3-0.8,0-0.8,0.3c0.3,1.2,0.1,2.5-0.4,3.7 c-0.7,0.6-1.5-0.5-1.7,0c0.2,3.6,1.4,7.2,3.6,10.1c0.8,1.1,2.2,1.5,3.4,1.1c0.6-0.3,1-0.9,1.1-1.6c0-3.3-3.8-5.1-4.5-8.2 c-0.4-1.3,0-2.8,0.9-3.8c1.2-1,2.8-1.2,4.2-0.7c0.6,0.1,1,0.6,1,1.2c0,0.4,0,0.9-0.7,1c-0.5,0-1.2,0-1.4-0.5 c0-0.5-0.5-0.8-1-0.8c-0.6,0-1.3,0.3-1.7,0.8c-1,1.4,0,3.1,0.7,4.3c1.7,2.6,5.2,5.1,3.2,8.4c-0.5,0.7-1.3,1.2-2.2,1.3 c-1.4,0-2.8-0.6-3.7-1.7c-0.8,1.3-0.3,3,0.4,4.1c1.5,2,3.6,4.9,2.8,6.5c-0.5,0.6-1.7-0.5-1.6,0.8V68c0,1.1-1.5,0.7-2.2,0.7 c-0.3-0.2-0.4-0.6-0.3-0.9l0,0c0.3-0.4,1.3,0.1,1.3-0.4c0.2-1.6,0-3.2,0.2-4.9c0-0.4,0.4-0.7,0.8-0.7c0.3,0,0.7,0.2,0.8-0.2 c-0.6-3.3-4.7-5.4-3.6-9.3l0.5-1.5c-1.9-3.1-3-6.6-3.1-10.2c0-0.4,0-0.8,0.5-0.9c0.7,0,1.4,0.6,1.6,0.3c0.4-1.1,0-2.3-0.1-3.3 c0-0.7,1.3,0,1.2-0.8l-0.5-2.3c0.5-0.4,1.3-0.8,1.4-1.6c0.2-0.5,0-1-0.4-1.2c-0.1,0-0.2,0-0.4,0c-0.7,0.2-1.4-0.3-1.6-1l0,0 c0-0.5-0.1-1.1-0.9-1.1c-0.9,0-1.8,0-2.7,0c-0.4-0.4-0.8-1-1.4-0.8c-0.6,0.3-1,1-1.1,1.7v1.1c-0.5,0.6-2.1,1.2-2,1.9 c0.2,0.5,1,0.5,0.8,1.1c-0.4,0.4-0.8,0.2-1.3-0.1c-0.5-0.3-0.7-1-0.3-1.6l0,0c0.5-0.7,1.2-1.3,2-1.6c-0.2-0.9,0-1.7,0.5-2.5 c0.3-0.5,0.8-0.8,1.4-1C66.9,26.8,67.4,27.4,67.8,27.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_212",
    className: "st0",
    d: "M25,28c0.5,0.7,0.8,1.7,0.6,2.6c0.9,0.3,1.6,0.9,2,1.8c0.6,1-0.7,1.4-1.2,1.6 c-0.2,0-0.4,0-0.5-0.2l0,0c-0.1-0.6,1.1-0.5,0.7-1.2c-0.4-0.9-1.4-1.1-2-1.6c0.3-0.8,0.2-1.7-0.4-2.4c-0.3-0.3-0.8-0.8-1.3-0.3 c-0.8,1.3-2.4,0.4-3.5,0.6s-0.5,2-2,2.1c-0.4,0-1.1,0-1.2,0.7c0,0.7,0.3,1.4,0.9,1.8c1.2,0.5,0.6,1.4,0.3,2.2 c-0.1,0.4-0.3,0.8,0,0.9c0.4,0,1-0.1,1,0.5c-0.1,1.1-0.4,3.1,0,3.4c0.4,0.2,1-0.8,1.6-0.3c0.3,0.7,0.4,1.5,0.2,2.3 c-0.2,2.1-0.8,4.1-1.7,6l-1.3,2.9c0.8,1.7,0.7,3.7-0.2,5.4c-1,1.8-3.1,4-3,5.3c0,0.4,1.5-0.4,1.6,0.6c0,1.7,0,3.4,0.2,5.1 c0,0.5,1.3-0.2,1.4,0.6c0,0.5,0,0.7-0.6,0.7s-1.8,0.2-1.9-0.9v-4.8c-0.3-0.8-1.4,0.4-1.7-0.5c-0.7-4.1,5-6.3,3.3-10.5L16,52.8 c-1,1.2-2.6,1.6-4,1c-1.3-0.4-2.1-1.6-2.2-3c0.1-3.8,4.9-5.8,4.8-9.6c0-0.7-0.4-1.4-1.1-1.7c-0.5-0.3-1.1-0.3-1.6,0 c-0.6,0.3-0.4,1.1-1.2,1.2c-0.5,0.2-1.1-0.1-1.3-0.7l0,0c-0.2-0.6,0.1-1.3,0.7-1.6c1.4-0.6,3-0.5,4.3,0.3c1.1,1,1.5,2.6,1,4 c-0.6,2.8-3.7,4.5-4.4,7.2c-0.2,0.7,0,1.5,0.4,2.1c0.4,0.5,1.1,0.8,1.8,0.8c2-0.2,3-2,3.8-3.4c1.3-2.3,2.1-4.9,2.3-7.6 c0.2-1.2-1.4,0.5-1.7-0.4c-0.4-1.2-0.5-2.6-0.2-3.9c-0.4,0-1.2,0-1.2-0.6c0-0.9,0.5-1.9,0.4-2.5c-0.7-0.5-1.2-1.2-1.4-2.1 c-0.2-0.6,0-1.2,0.3-1.6c0.7-0.6,2.1,0,2.1-1.3c0.1-0.5,0.3-1.2,1.1-1.4c1.1-0.2,2.7,0.3,3.2,0s0.7-0.9,1.3-0.9 C23.9,27.1,24.5,27.5,25,28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_213",
    className: "st0",
    d: "M46.3,28.3l-1.1,0.6l-2.5,1.4c0.5,0.4,0.5,1.1,0.2,1.7c-0.3,0.7-0.8,1.2-1.4,1.7 c-0.3,0-0.6,0-0.7-0.4l0,0c0.2-0.8,1.6-1.6,1.1-2.3l-2.3-2.3c-0.2-0.2-0.2-0.3,0-0.6c0.2-0.2,0.5-0.2,0.8,0.1l1.6,1.3l3.7-1.8 c0.9-0.5,1.2,0.5,0.8,0.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_214",
    className: "st0",
    d: "M58.1,28.6c0.2,0.4-1.5,0.9-0.7,2.1c1.2,1.9,2.9,3.5,4.9,4.6c0.5,0.3-0.7,1.4-0.7,2.3 c0.5,0.2,1.6,0.2,1.6,0.9c0.5,3.8-7.8,3.7-6.5,7.8c0.2,0.4,0.7,0.4,1.1,0.2c0,0,0,0,0.1,0c0.4-0.2,0.3-1.4,0.6-2.1 c0.5-1.1,1.8-1.2,3-1.2c0.7,0,0.2,1.5,1.1,1.2c1-1,1.1-2.5,2.3-3.1c0.3-0.1,0.6,0,0.7,0.3l0,0c-0.2,0.7-0.6,1.3-1.1,1.8 c-0.4,0.7-0.7,1.6-1.6,1.9c-0.4,0.2-0.9,0.2-1.3,0c-0.5-0.3-0.2-1-0.8-1.1c-0.6,0-1.2,0.2-1.5,0.7c-0.4,0.9,0,2.5-1.3,2.7 c-0.7,0-1.5,0.3-2-0.4c-0.7-1.6-0.2-3.4,1.2-4.5v-6.9H46.5c0.3-0.6,0.9-0.9,1.6-1h4.2c0.4,0.5,1,0.7,1.7,0.6 c0.3,0,0.7-0.4,0.8-0.6h3.7v7.1l0,0c1.5-0.7,2.5-1,3.6-2.2c0.9-1.2-0.9-1-1.4-1.3s0.4-1.5,0.5-2.4c-2.6-1.3-4.4-4-5.5-6.5 c-0.5-0.5-1.1,0.5-1.3,1c-0.2,0.4,0,0.9,0.5,1.2c0.3,0.2,0.6,0.4,0.4,0.8s-0.4,1.2-0.8,0.9c-0.4-0.3-1.3-0.3-0.8-1 c0.5-0.5-0.2-0.7-0.3-1.5c0-0.8,0.5-1.6,1.2-2.1c0.4-0.3,1.1-0.9,1.5-0.6l0.3,0.4c0.3-0.2,0.5-1,1-0.6L58.1,28.6L58.1,28.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_215",
    className: "st0",
    d: "M67.9,31.6c0,0.2,0,0.5-0.2,0.7l-0.9-0.7c-0.3-0.2-0.4-0.7-0.2-1l0,0c0.5,0.3,1,0.4,1.3,1.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_216",
    className: "st0",
    d: "M23.5,31.2c-0.2,0.5-0.8,0.4-1,1c-0.2,0-0.3-0.3-0.3-0.3c-0.1-0.8,0.8-1.1,1.3-1.3 C23.7,30.6,23.6,31.1,23.5,31.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_217",
    className: "st0",
    d: "M71.4,32.6c0,0,0,0.7-0.6,0.6c0,0-0.5,0-0.9-0.1c-0.2,0-0.5,0-0.7,0c0-0.4,0.3-0.8,0.7-0.8 C70.4,32.3,71,32.5,71.4,32.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_218",
    className: "st0",
    d: "M20.6,32.7c0.2,0.6-0.6,0-0.9,0.3c-0.3,0.2-0.7,0.2-0.9,0h-0.2 C19.1,32.5,20.1,31.9,20.6,32.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219",
    className: "st0",
    d: "M54.1,34.1c0,0.3,0,0.6-0.6,0.6c-0.4,0-0.8-0.4-0.9-0.8c0-0.3,0.2-0.5,0.4-0.6 C53.5,33.3,54,33.6,54.1,34.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_220",
    className: "st0",
    d: "M37.4,33.8c0,0.4-0.4,0.8-0.9,0.9c-0.3,0-0.7,0-0.7-0.4s0.4-0.8,0.8-0.9 c0.2-0.2,0.6,0,0.7,0.2c0,0,0,0.1,0,0.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    className: "st0",
    d: "M67.7,34.2c0.3,0.3,0.9-0.5,1.1,0.2c-0.3,0.2-0.8,0.3-0.5,0.7c0.2,0.3,0.6,0.3,0.9,0.5 c-0.2,0.3-0.7,0.2-1,0l-0.8-0.8c-0.6,0.2-1.2,0-1.6-0.5h0.1c0.4-0.1,0.9,0.2,1,0s0-0.7,0.5-0.7L67.7,34.2L67.7,34.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    className: "st0",
    d: "M23,34c0,0.2-0.2,0.4,0.2,0.4s0.8-0.2,1.1-0.1c-0.3,0.6-1.1,0.6-1.8,0.5 c-0.3,0.6-0.9,1.1-1.6,1l0,0c0.3-0.2,0.9-0.3,1.1-0.8c0-0.3-0.9-0.2-0.5-0.7c0.3,0,0.8,0.4,1.1,0c0-0.5,0.5-0.7,0.5,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    className: "st0",
    d: "M67.1,36.1c0.3-0.2,0.7-0.5,0.8,0c0,0.3-0.2,0.5-0.5,0.6c-0.5,0-1-0.1-1.3-0.5 c-0.2-0.3-0.2-0.6,0-0.9C66.9,34.9,66.1,36.3,67.1,36.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    className: "st0",
    d: "M24,35.8c0.1,0.5-0.4,0.9-0.8,1s-0.9,0-1.1-0.4c-0.1-0.2,0-0.3,0.2-0.3c0.3,0,0.7,0.4,1,0 c0.1-0.3,0-0.6,0.3-0.7C23.9,35.4,24,35.6,24,35.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    className: "st0",
    d: "M64.6,36.1c0,0.3-0.1,0.7-0.4,0.8l0,0c-0.4,0-0.7-0.2-0.8-0.6c0-0.3,0.2-0.7,0.5-0.8 C64.3,35.5,64.7,35.8,64.6,36.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    className: "st0",
    d: "M56.2,36.7c0.2,0.9-0.9,2-1.8,1.9c0-0.5,0.2-1,0.6-1.4C55.3,36.9,55.7,36.7,56.2,36.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_227",
    className: "st0",
    d: "M35.3,37.6l0.4,1c-0.6,0-1.1-0.2-1.5-0.6c-0.2-0.3-0.6-0.8-0.5-1.2 C34.3,36.8,34.9,37.1,35.3,37.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_228",
    className: "st0",
    d: "M54,37.4c0,0.2,0,0.5-0.2,0.6c0-0.2-0.3-0.5-0.5-0.5s-0.4,0-0.4-0.2c0-0.6,1-0.4,1.1,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_229",
    className: "st0",
    d: "M37.1,37.3c0,0.4-0.8,0.2-0.8,0.7C36,38,36,37.7,36,37.6c0-0.3,0.2-0.5,0.4-0.6 C36.7,37,37,37,37.1,37.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230",
    className: "st0",
    d: "M67.7,38.1c0.3,0.2,0,0.5,0,0.6c-0.2,0.4-2,0-2.8-0.7c-0.2-0.2,0-0.5,0-0.7 c0.6-0.2,1,0.4,1.4,0.5C66.8,38,67.1,37.8,67.7,38.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    className: "st0",
    d: "M25.2,37.7c0.1,0.6-0.7,0.8-1.2,1s-1.4,0.5-1.8,0.2c-0.1-0.2-0.1-0.5,0-0.7 c0.7-0.4,1.4-0.7,2.1-0.9c0.5-0.1,0.7,0,0.8,0.4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_111",
    x: 38.4,
    y: 37.6,
    className: "st0",
    width: 13.1,
    height: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    className: "st0",
    d: "M70,38.1c0,0.4-0.2,0.8-0.6,0.9c-0.4,0-0.7-0.2-0.8-0.6c0-0.4,0.2-0.7,0.6-0.8 C69.5,37.6,69.9,37.8,70,38.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_233",
    className: "st0",
    d: "M56.1,39.6c0,0.2,0,0.5-0.3,0.6c-0.4,0-0.2-0.8-0.8-0.8c0-0.2,0.2-0.2,0.3-0.3 C55.6,39.1,56,39.3,56.1,39.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_234",
    className: "st0",
    d: "M35,39.4c-0.6,0-0.4,0.8-0.9,0.9c-0.2-0.2-0.2-0.5,0-0.8C34.3,39.2,34.6,39.1,35,39.4 C34.9,39.3,35,39.3,35,39.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_235",
    className: "st0",
    d: "M51.7,54.7c0,0,0,1.7-0.6,1.8c-0.6,0-0.6-1.8-0.6-1.8h-2c0,0,0,1.8-0.5,1.8 c-0.6,0-0.6-1.8-0.6-1.8h-2c0,0,0,1.8-0.6,1.9c-0.6,0-0.6-1.9-0.6-1.9h-2c0,0,0,1.8-0.5,1.8c-0.7,0-0.6-1.8-0.6-1.8h-2 c0,0,0,1.8-0.5,1.7c-0.7,0-0.6-1.7-0.6-1.7V39.8h13.6L51.7,54.7L51.7,54.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_112",
    x: 39.2,
    y: 40.7,
    className: "st1",
    width: 2,
    height: 2.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_113",
    x: 42.3,
    y: 40.7,
    className: "st1",
    width: 2,
    height: 2.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_114",
    x: 45.4,
    y: 40.7,
    className: "st1",
    width: 2,
    height: 2.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_115",
    x: 48.6,
    y: 40.7,
    className: "st1",
    width: 1.9,
    height: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_236",
    className: "st0",
    d: "M35.5,47.7h-0.6v-6.3h0.6V47.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_116",
    x: 54.5,
    y: 41.4,
    className: "st0",
    width: 0.6,
    height: 6.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237",
    className: "st0",
    d: "M65.2,43.9c0.8,2.4,3.8,3.7,4.3,6.2c0,2.2-2.4,3.2-2.1,5.4c0.6,1.6,1.4,2.4,1.8,4.9 c0.9,0,1.3-1.7,1.7-1.8c0.6-0.3,1,0.6,1.4,1.2c0.9,1.7,1,3.6,0.4,5.4l-1.1,2c0,0.5,0.1,1.5-0.5,1.6c-0.3,0-0.6,0-0.7-0.3 c-0.1-0.6,0-1.2,0.1-1.7c0.2-0.2,2-3.2,1.5-5c-0.1-0.5-0.4-1.1-0.8-1.5c-0.7,0.8-1.7,1.3-2.8,1.3c-0.4,0-0.3-1.7-0.6-2.5 c-0.5-1.9-2.4-3.5-1.2-5.6c0.7-1.4,2.7-2.8,1.2-4.4c-1.1-1.3-2.7-2.4-3.2-3.9c0-0.5,0-1.3,0.6-1.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238",
    className: "st0",
    d: "M25.3,44.5c-0.1,2.1-2.3,3.3-3.4,4.9c-1.5,1.8,2.1,3.4,1.8,5.8c-0.2,1.5-1,2.5-1.5,3.9 l-0.7,2.3c-0.3,0.5-1.5-0.2-2.2-0.8c-0.2,0-0.4-0.6-0.7-0.3c-0.8,1.2-1,2.7-0.6,4.1c0.3,1,1.4,1.8,1.5,2.6 c0,0.5,0.2,1.8-0.4,1.9c-1.2,0-0.4-1.4-0.8-2c-1.2-1.4-1.7-3.3-1.4-5.1c0.3-1.2,1-2.8,1.8-3.1c0.5,0,0.6,0.5,1.1,1.1 c0.3,0.2,0.9,0.8,0.8,0.4l0.7-2.1c0.5-1.3,2.1-2.9,0.7-4.5c-1-1.4-2.3-3-1.2-4.7c1.2-1.7,3.1-3,3.7-4.9 C24.9,43.5,25.3,44,25.3,44.5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_117",
    x: 39,
    y: 44.4,
    transform: "matrix(1.745302e-03 -1 1 1.745302e-03 -5.2794 85.4595)",
    className: "st1",
    width: 2.4,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_118",
    x: 42.3,
    y: 44.1,
    className: "st1",
    width: 2,
    height: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_239",
    className: "st1",
    d: "M47.5,46.6h-2v-2.4h2V46.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240",
    className: "st1",
    d: "M50.5,46.6h-2v-2.4h2V46.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241",
    className: "st0",
    d: "M66.5,48.9c0.3,0,0.7,0,0.7,0.5c0,0.3-0.2,0.5-0.4,0.5l0,0c-1.4-0.3-2.5-1.2-3.7-1.6 c-0.7-0.2-1.2,0.4-1.5,0.9L60,52.4c0.4,0.5,1.5,0,1.5,0.8c0,2.7-0.4,5.3-2.9,6.4c-2,1.2-1.2,2.1-1.5,2.4c-0.2,0.2-0.5,0.2-0.7,0 c-0.3-0.5-0.4-1-0.2-1.6c0.7-1.7,2.9-1.6,3.5-3.3c0.6-1.1,0.8-2.3,0.7-3.5C60,53.3,59,53.5,59,52.7c0.3-1.6,1-3.1,2.1-4.3 c0.3-0.5,0.9-0.9,1.5-1c1.5,0,2.6,1.2,3.9,1.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242",
    className: "st0",
    d: "M28.8,48.4l1.9,3.3c0.2,0.6,0.3,1.2,0,1.3l-1.1,0.4c-0.5,0.1-0.2,3.2,1.3,4.6 c1.1,1.2,3.4,1.6,2.9,3.5c0,0.2,0,0.5-0.3,0.5c-1,0-0.4-1.3-0.9-1.6c-1.2-1.2-2.7-1.5-3.5-3.3c-0.5-1.3-0.7-2.8-0.6-4.2 c0.3-0.5,1.6-0.2,1.3-0.8l-1.7-3.2c-0.4-0.5-0.8-0.9-1.5-0.5c-1.2,0.5-2.1,1.4-3.4,1.6c-0.5,0-0.8-0.5-0.5-0.7l0.7-0.3 c1.2-0.5,2.3-1,3.4-1.6C27.4,47.1,28.3,47.4,28.8,48.4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_119",
    x: 39.2,
    y: 47.6,
    className: "st1",
    width: 2,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_120",
    x: 42.3,
    y: 47.6,
    className: "st1",
    width: 2,
    height: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_243",
    className: "st1",
    d: "M47.5,50h-2v-2.5h2V50z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_121",
    x: 48.6,
    y: 47.6,
    className: "st1",
    width: 1.9,
    height: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_244",
    className: "st0",
    d: "M58.6,49c0.4,6.4-3.2,11.9-8.5,15.4c-1.6,1.1-3.3,1.9-5.2,2.4c-5.8-2.1-12.4-7.7-13.3-14.3 c-0.2-1.4-0.3-2.8,0-4.2c0.5,0,0.9,0.2,1.3,0.3c-0.4,6.2,3.2,11.6,8.4,14.8c1.2,0.7,2.5,1.3,3.8,1.8c5.5-1.9,11.2-7,12.1-12.9 c0.2-1.2,0.3-2.4,0.2-3.6c0.4-0.1,0.8-0.2,1.3-0.3v0.8L58.6,49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_245",
    className: "st0",
    d: "M54.8,49c0,0.4-0.2,0.6-0.5,0.7H54c0.4-0.3,0-0.9,0.3-1.2C54.6,48.5,54.8,48.7,54.8,49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_246",
    className: "st0",
    d: "M35.8,48.6c0,0.4-0.3,0.8,0,1.1c-0.2,0.2-0.4,0-0.6-0.2c-0.3-0.2,0-0.6,0-0.8 C35.4,48.7,35.6,48.5,35.8,48.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247",
    className: "st0",
    d: "M56.6,50.8c-0.3,0.4-0.9,0.3-1.5,0.3c-0.4,0-0.8-0.3-1.1-0.6c0-0.4,0.6-0.4,0.9-0.5 C55.6,50,56.2,50.2,56.6,50.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_248",
    className: "st0",
    d: "M36,50.5c-0.4,0.5-1,0.7-1.6,0.7c-0.3,0-0.9,0-1-0.4c0.3-0.4,0.7-0.6,1.2-0.7 C35.1,50.1,35.7,50.1,36,50.5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_122",
    x: 39.2,
    y: 51,
    className: "st1",
    width: 2,
    height: 2.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_123",
    x: 42.3,
    y: 51,
    className: "st1",
    width: 2,
    height: 2.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_124",
    x: 45.4,
    y: 51,
    className: "st1",
    width: 2,
    height: 2.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_125",
    x: 48.6,
    y: 51,
    className: "st1",
    width: 2,
    height: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_249",
    className: "st0",
    d: "M54.4,52c0,0.3-0.2,0.5-0.4,0.6c-0.2,0-0.4,0-0.4-0.2c0.3-0.2,0.4-0.6,0.3-1 C54.2,51.4,54.4,51.7,54.4,52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_250",
    className: "st0",
    d: "M36.1,52c0,0.2,0.4,0.3,0.3,0.6c-0.2,0-0.5,0-0.7-0.2s-0.2-0.6,0-0.8 C36.1,51.2,36.2,51.6,36.1,52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_251",
    className: "st0",
    d: "M66.3,52.1c0,0.2,0,0.5,0,0.6c-0.7,0.2-1.8,0-2.3,0.8c-0.9,1.2-0.2,2.8,0.3,3.9 c0,0.3-0.3,0.5-0.6,0.4c-0.6,0-0.7-0.9-0.9-1.3c-0.6-1.4-0.3-2.9,0.6-4C64.1,51.7,66.1,51.7,66.3,52.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_252",
    className: "st0",
    d: "M26.8,52.7c0.8,1.2,1,2.7,0.4,4c-0.2,0.5-0.4,1.4-1.3,1.2l-0.2-0.3c-0.2-0.6,1.6-3.2,0.2-4.3 c-0.8-0.8-2.3,0.4-2.2-1.1c0-0.6,2.1-0.5,3.2,0.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_253",
    className: "st0",
    d: "M54.9,53.4c-0.6,2.4-2,4.5-3.9,6c-0.5,0.4-1,0.9-1.6,0.9c-0.2,0-0.3-0.2-0.3-0.3 c0,0,0,0,0-0.1c2.4-1.5,4.2-3.8,5.1-6.5h0.6L54.9,53.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_254",
    className: "st0",
    d: "M40.7,59.8c0.5,0.3,0,0.6-0.2,0.5c-2.2-0.7-4.7-4.2-5.4-6.7l0.6-0.3 C36.6,55.9,38.4,58.2,40.7,59.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_255",
    className: "st0",
    d: "M62.7,58.1c0,0.6-0.5,0.6-0.7,0.9c-0.8,1-0.8,2.6-2.2,3c-0.5,0.1-0.9,0-1.4,0 c-0.2-0.2-0.2-0.5,0-0.7c0.3-0.5,0.9,0,1.3-0.2c1.2-0.8,0.9-2.5,2.3-3.2c0.3,0,0.7-0.2,0.8,0.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_256",
    className: "st0",
    d: "M29.6,60.6c0.4,0.9,2.3-0.2,1.9,1.3c-0.3,0.2-1.1,0-1.6,0c-1.6-0.6-1.2-2.5-2.6-3.2 c-0.3-0.2-0.2-0.8,0.2-0.8C29.1,57.9,29,59.5,29.6,60.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_257",
    className: "st0",
    d: "M47.8,59.5c0,0.4-0.4,0.8-0.7,0.9c-0.4,0-0.7-0.3-0.9-0.6c0,0-0.3-0.6,0-0.4 C46.7,59.7,47.5,59,47.8,59.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_258",
    className: "st0",
    d: "M43.8,59.3c0.2,0.4-0.3,0.8-0.6,0.9c-0.4,0.1-0.8,0-1-0.4c0-0.2,0-0.4,0-0.6 C42.3,58.8,43.3,59.6,43.8,59.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_259",
    className: "st0",
    d: "M44.8,62.9c-0.9-0.5-1.2-2.5,0-3.5C46.1,60.2,45.9,62.6,44.8,62.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_260",
    className: "st0",
    d: "M19.8,38.3c0-0.4,0.3-0.7,0.7-0.7s0.7,0.3,0.7,0.7S20.9,39,20.5,39l0,0 C20.1,39,19.8,38.7,19.8,38.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_261",
    className: "st0",
    d: "M25.3,36.3c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7S26.4,37,26,37S25.3,36.7,25.3,36.3 L25.3,36.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_262",
    className: "st0",
    d: "M39.5,24c0-0.4,0.3-0.7,0.7-0.7s0.7,0.3,0.7,0.7c0,0.4-0.3,0.7-0.7,0.7S39.5,24.4,39.5,24 L39.5,24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_263",
    className: "st0",
    d: "M41.8,24.1c0-0.4,0.3-0.7,0.7-0.7s0.7,0.3,0.7,0.7c0,0.4-0.3,0.7-0.7,0.7 S41.8,24.5,41.8,24.1L41.8,24.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_264",
    className: "st0",
    d: "M44,24.1c0-0.4,0.3-0.7,0.7-0.7s0.7,0.3,0.7,0.7c0,0.4-0.3,0.7-0.7,0.7S44,24.5,44,24.1 L44,24.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_265",
    className: "st0",
    d: "M46.3,24.1c0-0.4,0.3-0.7,0.7-0.7s0.7,0.3,0.7,0.7c0,0.4-0.3,0.7-0.7,0.7 S46.3,24.5,46.3,24.1L46.3,24.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_266",
    className: "st0",
    d: "M48.5,24.1c0-0.4,0.3-0.7,0.7-0.7s0.7,0.3,0.7,0.7c0,0.4-0.3,0.7-0.7,0.7 S48.5,24.5,48.5,24.1L48.5,24.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_267",
    className: "st0",
    d: "M42.1,12.2L41,13.5l1.1,1.3l1.1-1.3L42.1,12.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_268",
    className: "st0",
    d: "M47.7,12.2l-1.1,1.3l1.1,1.3l1.1-1.3L47.7,12.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_269",
    className: "st0",
    d: "M63.2,36.2c0-0.4,0.3-0.8,0.8-0.8s0.8,0.3,0.8,0.8c0,0.4-0.3,0.8-0.8,0.8l0,0 C63.6,37,63.2,36.7,63.2,36.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_270",
    className: "st0",
    d: "M68.6,38.3c0-0.4,0.3-0.8,0.8-0.8s0.8,0.3,0.8,0.8c0,0.4-0.3,0.8-0.8,0.8l0,0 C69,39.1,68.6,38.8,68.6,38.3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_126",
    x: 88.9,
    y: 3,
    className: "st1",
    width: 210,
    height: 76.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_271",
    className: "st0",
    d: "M158.5,32.9h-3.7V17.6h7.5c1.7,0,3.3,1.2,3.7,2.9c0.2,0.7,0.2,1.5,0,2.2 c-0.2,1.5-1.2,2.7-2.6,3.1h-0.2c1.9,0.9,2.6,3,3,4.8c0.2,0.7,0.3,1.5,0.4,2.3h-3.7c-0.2-1.5-0.5-3-1.1-4.4 c-0.3-0.8-0.8-1.4-1.5-1.4h-1.8L158.5,32.9L158.5,32.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_272",
    className: "st0",
    d: "M106.3,17.6h5.6l3.4,10.2l3.2-10.2h5.6l0.4,15.3h-3.7l-0.3-12.3l-3.9,12.3H113L109.1,21 l-0.6,11.9h-2.7l0.7-15.3L106.3,17.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_273",
    className: "st0",
    d: "M132.2,30.2h6.7v2.6h-10.5V17.5h10v2.6h-6.3v3.6h5.2v2.4h-5.2v4L132.2,30.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_274",
    className: "st0",
    d: "M217.3,32.9V17.6h3.7v12.7h6V33L217.3,32.9L217.3,32.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275",
    className: "st0",
    d: "M233.5,17.6v15.3h-3.9V17.6C229.6,17.6,233.5,17.6,233.5,17.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276",
    className: "st0",
    d: "M244.2,32.9h-3.8V20.2h-4.2v-2.6h12v2.6h-4.1v12.7H244.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_277",
    className: "st0",
    d: "M266.1,17.6h4.1l6.3,11.5V17.6h3v15.3h-4.9l-5.5-10.1v10.1h-2.9V17.6L266.1,17.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_278",
    className: "st1",
    d: "M160.5,19.9c1.5,0.2,1.7,0.9,1.9,1.5c0.2,0.9,0,1.8-0.4,2.6c-0.8,0.9-2.2,0.8-3.5,0.7v-4.8 C159.2,19.9,159.7,19.9,160.5,19.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_279",
    className: "st0",
    d: "M131.5,45.7c0,0,3.8-0.4,6.1-0.6c1.5,0,3,0,4.5,0l1.8,0.2c2.6,0.6,5.8,1.9,6.2,4.8 c0.6,2.5-0.5,5.1-2.7,6.4c-0.8,0.5-1.6,0.9-2.6,1.2c-2.1,0.7-4.7,0.4-7.1,0.4v5.2h-6.2C131.5,63.3,131.5,45.7,131.5,45.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_280",
    className: "st0",
    d: "M231.7,51.2c-2-2-5-2.6-7.6-1.7c-1.6,0.5-2.7,1.8-3.1,3.4c-0.6,2.1,0,5.4,1.9,6.8 c2.5,1.4,5.5,1.6,8.1,0.3c0.5-0.3,0.9-0.5,0.9-0.5l1.3,3.4c-1.5,0.8-3.1,1.3-4.7,1.5c-2,0.2-4,0.2-5.9-0.1 c-2.9-0.6-5.8-2-7.3-4.7c-1.3-2.6-1.5-6.9,0.3-9.3c1.3-2.3,3.6-4,6.2-4.6c2-0.4,4-0.5,6-0.2c1.8,0.2,3.5,0.8,5.1,1.6l-1.3,4.1 H231.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_281",
    className: "st0",
    d: "M188.2,45.7v13.9h9.2v3.7h-15.6V45.6h6.4L188.2,45.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_127",
    x: 202.6,
    y: 45.7,
    className: "st0",
    width: 6.3,
    height: 17.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_282",
    className: "st0",
    d: "M254.9,45.7V49h-9.3v3.7h7v3.2h-7v3.8h10v3.7h-16.2V45.7H254.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_283",
    className: "st1",
    d: "M143.3,51.3c0.2,1.2-0.4,2.5-1.5,3.1c-1.3,0.8-2.9,0.8-4.2,0v-5.6c1.3-0.7,2.9-0.7,4.3,0 C142.8,49.2,143.4,50.2,143.3,51.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_284",
    className: "st0",
    d: "M252.9,17.6l-5.1,15.3h3.8l1.2-3.5h5l1.2,3.5h3.8l-5.1-15.3h-4.9L252.9,17.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_285",
    className: "st1",
    d: "M257.1,26.8h-3.5l1.8-5.8l1.8,5.8H257.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_286",
    className: "st0",
    d: "M148.4,32.9h-3.8V20.2h-4.2v-2.6h12v2.6h-4.1v12.7H148.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_287",
    className: "st0",
    d: "M190.3,27.5v5.4h-3.7V17.6h6.5c3.3,0,4.7,1.7,4.7,5.2S195.9,27.8,190.3,27.5L190.3,27.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_288",
    className: "st1",
    d: "M192,19.9c1.5,0.2,2,0.9,2.1,1.5c0.3,0.9,0.2,2-0.4,2.7c-0.8,0.9-2.1,0.9-3.4,0.8v-5 C191,19.9,191.2,19.9,192,19.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_289",
    className: "st0",
    d: "M183,25.1c0,1.8-0.4,3.5-1.2,5.1c-1.2,1.9-3.4,3-5.6,2.9l0,0c-2.3,0.2-4.4-0.9-5.6-2.9 c-0.9-1.5-1.3-3.3-1.2-5.1v0.2c0-1.8,0.4-3.5,1.2-5.1c1.2-1.9,3.4-3,5.6-2.9l0,0c2.3-0.2,4.4,0.9,5.6,2.9 c0.9,1.5,1.3,3.3,1.2,5.1V25.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_290",
    className: "st1",
    d: "M179.2,25.1c0,0.7,0,1.3,0,2c-0.3,1.6-1,3.3-3,3.3l0,0c-2,0-2.7-1.7-3-3.3c0-0.7-0.1-1.3,0-2 v0.2c0-0.7,0-1.3,0-2c0.3-1.6,1-3.3,3-3.3l0,0c2,0,2.7,1.7,3,3.3c0,0.7,0.1,1.3,0,2V25.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_291",
    className: "st0",
    d: "M213.7,25.1c0,1.8-0.4,3.5-1.2,5.1c-1.2,1.9-3.4,3-5.6,2.9l0,0c-2.3,0.2-4.4-0.9-5.6-2.9 c-0.9-1.5-1.3-3.3-1.2-5.1v0.2c0-1.8,0.4-3.5,1.2-5.1c1.2-1.9,3.4-3,5.6-2.9l0,0c2.3-0.2,4.4,0.9,5.6,2.9 c0.9,1.5,1.3,3.3,1.2,5.1V25.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_292",
    className: "st1",
    d: "M209.9,25.1c0,0.7,0,1.3,0,2c-0.3,1.6-1,3.3-3,3.3l0,0c-2,0-2.7-1.7-3-3.3c0-0.7-0.1-1.3,0-2 v0.2c0-0.7,0-1.3,0-2c0.3-1.6,1-3.3,3-3.3l0,0c2,0,2.7,1.7,3,3.3c0,0.7,0.1,1.3,0,2V25.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_293",
    className: "st0",
    d: "M176.4,55.4c0,0.4,0,1,0,1.4c-0.2,0.7-0.4,1.4-0.6,2.1c-1.3,3.1-4.5,4.9-7.8,5.5 c-0.8,0.1-1.5,0.2-2.3,0.2l0,0c-0.8,0-1.5,0-2.3-0.2c-3.3-0.6-6.5-2.4-7.8-5.5c-0.3-0.7-0.5-1.4-0.6-2.1c0-0.4,0-1,0-1.4v-0.7 c0-0.4,0-0.9,0-1.4c0.2-0.7,0.4-1.4,0.6-2.1c1.3-3.1,4.5-4.9,7.8-5.5c0.8-0.1,1.5-0.2,2.3-0.2l0,0c0.8,0,1.5,0,2.3,0.2 c3.3,0.6,6.5,2.4,7.8,5.5c0.3,0.7,0.5,1.4,0.6,2.1c0,0.4,0,0.9,0,1.3C176.4,54.6,176.4,55.4,176.4,55.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_294",
    className: "st1",
    d: "M170.2,55.3c0,0.7-0.4,5.3-4.6,5.4l0,0c-4.3,0-4.7-4.7-4.7-5.4v-0.6c0-0.7,0.4-5.3,4.7-5.3 l0,0c4.3,0,4.6,4.7,4.6,5.4v0.6V55.3z"
  })))))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 86.5,
    y: 3.6,
    className: "st0",
    width: 2.4,
    height: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetPoliceLogoOutlined);
export default __webpack_public_path__ + "static/media/met-police-logo-outlined.18968632874e8ad216ca02d9eda79662.svg";
export { ForwardRef as ReactComponent };